<script>
    import ProcessStep from "@/router/views/dts/dts-modal/process-type-step.vue";
    import ProcessReq from "@/router/views/dts/dts-modal/process-type-req.vue";
    import {cloneDeep, groupBy} from "lodash";
    export default {
        components: {
            ProcessStep,
            ProcessReq,
        },
        data() {
            return {
                modalTitle: "Requirements and Steps",
                processType: "",
                parentData: {},
                steps: [],
                loadSteps: false,
                requirements: [],
                loadReqs: false,
                addNewReq: false,
                editReqMode: false,
                addNewStep: false,
                editStepMode: false,
            };
        },
        computed: {
            groupReqs(){
                let group = groupBy(this.requirements, "requirementGroup");
                let groups = [];
                for (const key in group) {
                    groups.push({
                        group: key,
                        items: group[key]
                    });
                }
                return groups.sort((a, b) => a.group.localeCompare(b.group));
            },
            groupSteps(){
                let group = groupBy(this.steps, "category");
                let groups = [];
                for (const key in group) {
                    groups.push({
                        group: key,
                        items: group[key]
                    });
                }
                return groups.sort((a, b) => a.group.localeCompare(b.group));
            }
        },
        methods: {
            async saveStep(data){
                data.processTypeId = this.parentData.id;
                data.order = data.order ? data.order : 0;
                data.processingTime = data.processingTime ? data.processingTime : 0;
                data.amount = data.amount ? this.getExactAmt(data.amount) : 0;
                data.category = data.categoryModel;
                if(data.id > 0){
                    await this.$store
                    .dispatch("processtypeclientsteps/UpdateClientStep", data)
                    .then((res) => {
                        if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                        }
                        var index = this.steps.findIndex((item) => item.id == data.id);
                        this.steps.splice(index, 1, data);
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                }else{
                    await this.$store
                    .dispatch("processtypeclientsteps/CreateClientStep", data)
                    .then((res) => {
                        if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.editMode = false;
                        res.data.categoryModel = cloneDeep(res.data.category);
                        this.steps.push(res.data);
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                }
            },
            removeStep(data){
                this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#dc3545",
                    cancelButtonColor: "#5c636a",
                    confirmButtonText: "Yes, delete it!",
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    this.$store
                        .dispatch("processtypeclientsteps/RemoveClientStep", data.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            var index = this.steps.findIndex((item) => item.id == data.id);
                            this.steps.splice(index, 1);
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                    }
                });
            },
            cancelStep(id){
                var index = this.steps.findIndex((item) => item.id == id);
                this.steps.splice(index, 1, this.steps[index].editData);
            },
            async saveReq(req){
                let data = cloneDeep(req);
                if(data.id > 0){
                    this.$store.dispatch("dtsreqs/UpdateProcessTypeRequirement", data).then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        var index = this.requirements.findIndex((item) => item.id == data.id);
                        data.editMode = false;
                        this.requirements.splice(index, 1, data);
                        this.showToast("Successfully updated!", "success");
                        this.addNewReq = false;
                        this.editReqMode = false;
                    }).catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                }else{
                    data.processTypeId = this.parentData.id;
                    this.$store.dispatch("dtsreqs/CreateProcessTypeRequirement", data).then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.requirements.push(res.data);
                        this.showToast("Successfully created!", "success");
                        this.addNewReq = false;
                        this.editReqMode = false;
                    }).catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                }
            },
            removeReq(row){
                this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#dc3545",
                    cancelButtonColor: "#5c636a",
                    confirmButtonText: "Yes, delete it!",
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    this.$store
                        .dispatch("dtsreqs/DeleteProcessTypeRequirement", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            var index = this.requirements.findIndex(
                                (item) => item.id == row.id
                            );
                            this.requirements.splice(index, 1);
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                    }
                });
            },
            async getReqs(id){
                this.loadReqs = true;
                await this.$store.dispatch("dtsreqs/GetProcessTypeRequirement", id).then((res) => {
                    if (res.data.error) {
                        this.loadReqs = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(x => {
                        x.editMode = false;
                    });
                    this.requirements = res.data;
                }).catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
                this.loadReqs = false;
            },
            async getSteps(id){
                this.loadReqs = true;
                await this.$store
                    .dispatch("processtypeclientsteps/GetClientSteps", id)
                    .then((res) => {
                        if (res.data.error) {
                            this.loadReqs = false;
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map(x => {
                            x.editMode = false;
                            x.category = x.category ? x.category : '';
                            x.categoryModel = cloneDeep(x.category);
                        });
                        this.steps = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Cannot be deleted!", "error");
                    });
                this.loadReqs = false;
            },
            async setData(parent){
                this.parentData = parent;
                this.getReqs(parent.id);
                this.getSteps(parent.id);
            },
            createNewReq(){
                this.addNewReq = true;
                this.editModeReq = false;
            },
            editReq(){
                this.editReqMode = true;
                this.addNewReq = false;
            },
            cancelReq(id){
                var index = this.requirements.findIndex((item) => item.id == id);
                this.requirements.splice(index, 1, this.requirements[index].editData);
                this.addNewReq = false;
                this.editReqMode = false;
            },
            cancelReqForm(){
                this.addNewReq = false;
                this.editReqMode = false;
            }
        },
    };
</script>
<template>
    <b-modal
        id="req-step-modal"
        :title="modalTitle"
        size="xxl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <h3 class="mb-0">Process Requirements</h3>
        <hr class="my-2">
        <ProcessReq
            :addNewReq="addNewReq"
            :editReqMode="editReqMode"
            :loading="loadReqs"
            :requirements="requirements"
            :groupReqs="groupReqs"
            @save="saveReq"
            @remove="removeReq"
            @add-new-req="createNewReq"
            @edit-req="editReq"
            @cancel="cancelReq"
            @cancel-form="cancelReqForm"
        />
        
        <h3 class="mb-0">Process Steps</h3>
        <hr class="my-2">
        <ProcessStep
            :addNew="addNewStep"
            :editMode="editStepMode"
            :loading="loadSteps"
            :steps="steps"
            :groupSteps="groupSteps"
            @save="saveStep"
            @remove="removeStep"
            @cancel="cancelStep"
        />
    </b-modal>
</template>